// When REACT_APP_UPLOAD_API_URL is empty, the backend is served from the same
// origin as the frontend (path-based /api/* on the CloudFront distribution).
const backendUrl = (process.env.REACT_APP_UPLOAD_API_URL || '').replace(/\/$/, '');

const readError = async (response) => {
  try {
    const body = await response.json();
    return body.description || body.error || body.message || `Request failed (${response.status})`;
  } catch {
    return `Request failed (${response.status})`;
  }
};

/** Send an encrypted IdentY capture BLOB to the backend for processing and storage. */
export const processFaceCapture = async (captureBlob, userId, debugId) => {
  const response = await fetch(`${backendUrl}/api/face/process`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/octet-stream',
      'X-Upload-User-Id': String(userId),
      ...(debugId ? { 'X-DEBUG': debugId } : {}),
    },
    body: captureBlob,
  });

  if (!response.ok) throw new Error(await readError(response));
  return { data: await response.json() };
};
